import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=e81587a6&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=e81587a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81587a6",
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BCol, BFormInput, BFormGroup, BButton, BRow, BForm, BCard, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BCol, BFormInput, BFormGroup, BButton, BRow, BForm, BCard, BContainer})
    

export default component.exports